module.exports = __webpack_public_path__ + "static/media/trs.36877e9e.png";